import { useState, useEffect } from "react";

import styles from "./List.module.css";
import PageTitleBarComponent from "../PageTitleBar/PageTitleBar";
import CardComponent from "../Card/Card";
import CertificatePopupComponent from "../CertificatePopup/CertificatePopup";

export default function ListPage(props) {
  const [popupData, setPopupData] = useState();
  const [showPopup, setShowPopup] = useState(false);

  const toggleShowPopup = (show) => {
    setShowPopup(show);
  };

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        toggleShowPopup(false);
      }
    };
    window.addEventListener("keydown", handleEsc);

    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, []);

  return (
    <>
      <PageTitleBarComponent pageTitle={props.pageTitle} />
      <section className={styles.listContainer}>
        {props.data.map((item, index) => {
          let animation = " animate__animated animate__fadeInUp animate__slow ";

          if (window.innerWidth > 1150) {
            switch (index) {
              case 0:
              case 1:
                animation += "";
                break;
              case 2:
              case 3:
                animation += "animate__delay-1s";
                break;
              case 4:
              case 5:
                animation += "animate__delay-2s";
                break;
              case 6:
              case 7:
                animation += "animate__delay-3s";
                break;
              case 8:
              case 9:
                animation += "animate__delay-4s";
                break;
              case 10:
              case 11:
                animation += "animate__delay-5s";
                break;
              default:
                animation += "animate__delay-5s";
                break;
            }
          } else {
            switch (index) {
              case 0:
                animation += "";
                break;
              case 1:
                animation += "animate__delay-1s";
                break;
              case 2:
                animation += "animate__delay-2s";
                break;
              case 3:
                animation += "animate__delay-3s";
                break;
              case 4:
                animation += "animate__delay-4s";
                break;
              case 5:
                animation += "animate__delay-5s";
                break;
              default:
                animation += "animate__delay-5s";
                break;
            }
          }

          return (
            <button
              key={index}
              className={
                animation +
                " " +
                styles.cardContainer +
                " " +
                (item.popup && styles.cardInteractions)
              }
              onClick={
                item.popup &&
                (() => {
                  setPopupData(item);
                  setShowPopup(true);
                })
              }
            >
              <CardComponent item={item.card} />
            </button>
          );
        })}
      </section>
      {showPopup && (
        <CertificatePopupComponent
          toggleShowPopup={toggleShowPopup}
          popupData={popupData}
        />
      )}
    </>
  );
}
